export const environment = {
    production: false,
    apiUrl: 'https://ws-toyosa.toyosa-test.com',
    apiUrl2: 'https://ws-toyosa.toyosa-test.com/api/v2',
    base_url: 'https://ws-plataforma-toyota.toyosa-test.com/api/v1',
    //apiUrl: 'https://ws-toyosa.toyosaapis.com',
    //apiUrl2: 'https://ws-toyosa.toyosaapis.com/api/v2',
    //base_url: 'https://ws-plataforma-toyota.toyosaapis.com/api/v1',
    api_key_maps: 'AIzaSyBk6-zusArk27Q-a6ZPp44iLFmQG_ckXSA'
};